/**
 * Role-dependent assistant copy. Staff (super admin) strings are the
 * original platform-ops wording and must not drift (regression-tested in
 * copy.test.ts); bank admins get org-scoped wording because the agent
 * restricts their data to their organization's brands.
 */
export interface AssistantCopy {
  suggestions: string[]
  emptyTitle: string
  emptySubtitle: string
  pageSubtitle: string
}

const STAFF_COPY: AssistantCopy = {
  suggestions: [
    "How many leads were captured last week, grouped by source?",
    "Which subscriptions had dashboard visits yesterday?",
    "What are the most recent pricing failures?",
    "Create a new loan officer"
  ],
  emptyTitle: "Ask about platform analytics and operations",
  emptySubtitle:
    "Leads, subscriptions, pricing failures — or admin actions with approval",
  pageSubtitle:
    "Ask about leads, subscriptions, and pricing — admin actions run only after your approval"
}

const BANK_ADMIN_COPY: AssistantCopy = {
  suggestions: [
    "How many leads did we capture last week, grouped by source?",
    "Which of our subscriptions visited their dashboard yesterday?",
    "Any pricing failures for our brands this week?",
    "Create a new loan officer"
  ],
  emptyTitle: "Ask about your organization's analytics",
  emptySubtitle:
    "Leads, subscriptions, pricing — admin actions run only after your approval",
  pageSubtitle:
    "Ask about your organization's leads, engagement, and pricing — actions run only after your approval"
}

export const getAssistantCopy = (isSuperAdmin: boolean): AssistantCopy =>
  isSuperAdmin ? STAFF_COPY : BANK_ADMIN_COPY
